import createLibraryLoggerProvider, { LibraryLoggerLevel } from "librarylog";

// Create logger
const loggerProvider = createLibraryLoggerProvider();
loggerProvider.configureFiltering({
  dev: true,
  internal: true,
  min: LibraryLoggerLevel.TRACE,
});
export const rootLogger = loggerProvider.getLogger().named("WorldStateDemo");
